import "./CeremonyMaster.css";

const phoneNumber = "+36703678880";

export default function CeremonyMaster(): JSX.Element {
  return (
    <section
      className="ceremonyMaster"
      id="ceremony-master"
      aria-labelledby="ceremony-master-title"
    >
      <div className="container">
        <article className="ceremonyMaster__card">
          <div className="ceremonyMaster__portrait">
            <img
              src="/images/soltesz.jpg"
              alt="Soltész Zoltán ceremóniamester"
              width="1181"
              height="1772"
              loading="lazy"
            />
          </div>

          <div className="ceremonyMaster__content">
            <header className="ceremonyMaster__heading">
              <p className="ceremonyMaster__eyebrow">Ceremóniamester</p>
              <h2 id="ceremony-master-title">Soltész Zoltán</h2>
              <p className="ceremonyMaster__location">Szolnok</p>
            </header>

            <p className="ceremonyMaster__introduction">
              Zoltán gondoskodik róla, hogy a nap eseményei gördülékenyen
              kövessék egymást, és a meghatározó pillanatok örök, boldog
              emlékként maradjanak meg.
            </p>

            <div className="ceremonyMaster__notice">
              <p className="ceremonyMaster__noticeLabel">Az esküvő napján</p>
              <p>
                Kérdéssel, kéréssel vagy váratlan helyzettel őt keressétek.
              </p>
            </div>

            <div className="ceremonyMaster__contact">
              <a
                className="ceremonyMaster__phone"
                href={`tel:${phoneNumber}`}
                aria-label="Soltész Zoltán hívása a +36 70 367 8880 telefonszámon"
              >
                <span>Telefon</span>
                <strong>+36 70 367 8880</strong>
              </a>

              <div className="ceremonyMaster__socials" aria-label="Facebook-oldalak">
                <a
                  href="https://www.facebook.com/solteszceremonia/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Ceremóniamester-oldal
                </a>
                <a
                  href="https://www.facebook.com/zoltan.soltesz.3/?locale=hu_HU"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook-profil
                </a>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}
